import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExtraStyleType } from 'components/Common/Formik/FieldCustom/FieldCustom';
import SelectFieldCustom from 'components/Common/Formik/SelectFieldCustomer/SelectFieldCustom';
import TextareaFieldCustom from 'components/Common/Formik/TextareaFieldCustom/TextareaFieldCustom';
import { formSubjects } from 'model/ContactFormFields';
import styles from '../ContactPage.module.scss';

function ContactMyRequest({
  extraStyle,
}: {
  extraStyle: ExtraStyleType;
}): JSX.Element {
  const { t } = useTranslation(['contactPage', 'translation']);

  return (
    <>
      <h2>{t('LABEL_MY_REQUEST')}</h2>
      <SelectFieldCustom
        label={t('LABEL_SUBJECT')}
        name="subject"
        options={formSubjects}
        required
        extraStyle={extraStyle}
      />
      <TextareaFieldCustom
        label={t('LABEL_MESSAGE')}
        name="message"
        required
        rows={15}
        extraStyle={{ ...extraStyle, input: styles.fieldInputTextarea }}
      />
    </>
  );
}

export default ContactMyRequest;
